import Loading from "../Infrastructure/Loading";

export default function Redirecting() {
  return (
    <div className="redirecting">
      <Loading />
      <div>Redirecting...</div>
    </div>
  );
}
